"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSearch = void 0;
var React = __importStar(require("react"));
var IconSearch = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M4,10.5 C4,6.916 6.916,4 10.5,4 C14.084,4 17,6.916 17,10.5 C17,14.084 14.084,17 10.5,17 C6.916,17 4,14.084 4,10.5 M20.854,20.152 L16.14,15.428 C17.294,14.108 18,12.387 18,10.5 C18,6.364 14.636,3 10.5,3 C6.364,3 3,6.364 3,10.5 C3,14.636 6.364,18 10.5,18 C12.39,18 14.113,17.292 15.433,16.136 L20.146,20.859 C20.244,20.957 20.372,21.006 20.5,21.006 C20.628,21.006 20.755,20.957 20.853,20.859 C21.049,20.665 21.049,20.349 20.854,20.152" }))); };
exports.IconSearch = IconSearch;
exports.IconSearch.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconSearch;
